import { Reveal, Eyebrow, H2 } from './shared';
import { cn } from '@/lib/utils';

const CARDS = [
  { tag: 'A rotina', text: 'Você passa creme todo dia, no corpo, nas mãos, depois do banho.' },
  { tag: 'O problema', text: 'Arde, repuxa ou coça. Mesmo nos que dizem “suave”.' },
  { tag: 'O custo', text: 'Você troca de marca, gasta, e a pele fica seca enquanto isso.' },
  { tag: 'A saída', text: 'Tirar a causa mais comum de irritação: o perfume.', dark: true },
];

export const StorySection = () => (
  <Reveal as="section" className="bg-v2-bg text-v2-ink py-16 md:py-24">
    <div className="container mx-auto px-5 max-w-6xl">
      <Eyebrow>Você conhece essa história</Eyebrow>
      <H2 className="max-w-3xl">Você já passou por isso? Comprou um hidratante e, quando passou na pele, ardeu.</H2>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {CARDS.map((c) => (
          <div
            key={c.tag}
            className={cn(
              'rounded-2xl p-5 md:p-6 min-h-[150px]',
              c.dark ? 'bg-v2-ink text-v2-bg' : 'bg-background border border-v2-ink/10',
            )}
          >
            <p className={cn('text-sm font-semibold uppercase mb-3', c.dark ? 'text-v2-bg/75' : 'text-v2-blue')}>{c.tag}</p>
            <p className="font-narrow text-xl md:text-2xl leading-snug font-medium">{c.text}</p>
          </div>
        ))}
      </div>
    </div>
  </Reveal>
);
